﻿﻿
const ICO = {

        buildNumber : '3.2',
        croppieReady : Promise.resolve(),
        //added support for calculated dates
  loadScript : function(src){
     return new Promise(function(resolve, reject){
        var script = document.createElement('script');
        script.src = src;
        script.onload = resolve;
        script.onerror = reject;
        document.head.appendChild(script);
     });
  },
  loadStyle : function(href){
     return new Promise(function(resolve, reject){
        var link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = href;
        link.onload = resolve;
        link.onerror = reject;
        document.head.appendChild(link);
     });
  },
  ajax : function(settings){
     var options = {
        method: settings.method || 'GET',
        headers: settings.headers || {}
     };
     var method = options.method ? options.method.toUpperCase() : 'GET';
     if(settings.data && method !== 'GET' && method !== 'HEAD') options.body = settings.data;
     return fetch(settings.url, options).then(function(res){
        if(!res.ok){
           return res.text().then(function(text){
              var err = new Error('Request failed');
              err.status = res.status;
              err.responseText = text;
              throw err;
           });
        }
        return res.text().then(function(text){
           try { return JSON.parse(text); } catch(e){ return text; }
        });
     }).then(function(data){
        if(typeof settings.success === 'function') settings.success(data);
        return data;
     }).catch(function(err){
       if(typeof settings.error === 'function') settings.error(err);
       throw err;
    });
  },
  appendFields : function(form, fields){
     for(var key in fields){
        if(fields.hasOwnProperty(key)){
           form.append(key, fields[key]);
        }
     }
  },
  init : function(settings){

   ICO.settings = settings;

   if (ICO.settings.debug === true) console.log(ICO.settings);

   ICO.views = [];

   ICO.scriptURL = settings.script_url ?? new URL('.', import.meta.url).href.replace(/src\/js\/modules\/$/, '');

   ICO.loadStyle(ICO.scriptURL + 'public/styles/ICO.css');
   ICO.loadStyle(ICO.scriptURL + 'public/styles/croppie.css');

   ICO.optionalParams();
   ICO.layout();

      //redirect message
      if (ICO.settings.redirect !== undefined){
         console.log("After successful transaction, ICO will redirect to " + ICO.settings.redirect);
      }


},
   
   getPrice : function(){
	if (ICO.params.perCardCost==true && ICO.params.payOnCheckout==true){

   
      var settings = {
        'url': ICO.vars.apiUrl+'organizations/' + ICO.settings.organization_id + '/card_templates/' + ICO.settings.card_template_id + '/price?number_of_copies=1&shipping_provider_id='+ICO.params.shipID,
        'method': 'GET',
        'headers': {
          'authorization': 'bearer '+ ICO.settings.api_token,
          'cache-control': 'no-cache',
        },
        'error' : function(data){
           if (ICO.settings.debug == true){
              console.log("per card error:");
              console.log(data);
           }
           ICO.callError(ICO.vars.createError);
        },

         };

    ICO.ajax(settings).then(function (response) {
         if (ICO.settings.debug == true)
              {console.log("Per card price ajax response:");
              console.log(response);}
			
         var cardPrice = response && response.card_price;
         var shippingPrice = response && response.shipping_price;
         if (typeof cardPrice !== 'string' || typeof shippingPrice !== 'string'){
            if (ICO.settings.debug == true){
               console.log('Per card price response missing expected fields. Skipping price calc.');
            }
            ICO.settings.price = undefined;
            return;
         }

			var crdp = parseFloat(cardPrice.replace('$',''));
			var shpp = parseFloat(shippingPrice.replace('$',''));
			
			if (ICO.params.intShip == false){
				ICO.settings.price = crdp + shpp;
			} else {
				ICO.settings.price = crdp;
			}
			
			
			
			   if (ICO.settings.price !== undefined){
                 //console.log('price is set as '+ICO.settings.price);
            ICO.perCard();	      
           }else{
              ICO.settings.price='no price';
               //console.log('no price declared');
           }
       });
	
		
	      
	   }
	   
	},    
          
      
     perCard : function(){
        var bc = document.getElementById('ICO-breadcrumbs');
       var ppc = document.createElement('h4');
        ppc.id = 'ICO-per-card-cost';
        ppc.setAttribute('class', 'ICO-center ICO-ppc');
        bc.appendChild(ppc);

        if (ICO.params.intShip == true){
                var cString = ICO.vars.perCard2;
        } else var cString = ICO.vars.perCardDom;

        //console.log(ICO.vars.perCard1);
        var txt = document.createTextNode(ICO.vars.perCard1 +'$'+(ICO.settings.price.toFixed(2) + cString));
        ppc.appendChild(txt);
   },
   adjustPreviewImages : function(){
      var resetClasses = [
         'ICO-card-img',
         'ICO-card-img-port',
         'ICO-card-img-fin',
         'ICO-card-img-fin-port',
         'ICO-card-img-sing',
         'ICO-card-img-port-sing',
         'ICO-card-img-fin-sing',
         'ICO-card-img-fin-port-sing'
      ];

      var setClassForImage = function(img){
         if(!img || !img.naturalWidth || !img.naturalHeight){ return; }

         resetClasses.forEach(function(cls){ img.classList.remove(cls); });

         var isPortrait = img.naturalHeight > img.naturalWidth;
         var isFinal = img.id === 'ICO-success-card' || img.className.indexOf('ICO-card-img-fin') !== -1;
         var isSingle = img.className.indexOf('sing') !== -1 || img.id === 'ICO-success-card' && ICO.settings.no_back === true;

         var landscapeClass;
         var portraitClass;

         if(isFinal && isSingle){
            landscapeClass = 'ICO-card-img-fin-sing';
            portraitClass = 'ICO-card-img-fin-port-sing';
         }else if(isFinal){
            landscapeClass = 'ICO-card-img-fin';
            portraitClass = 'ICO-card-img-fin-port';
         }else if(isSingle){
            landscapeClass = 'ICO-card-img-sing';
            portraitClass = 'ICO-card-img-port-sing';
         }else{
            landscapeClass = 'ICO-card-img';
            portraitClass = 'ICO-card-img-port';
         }

         img.classList.add(isPortrait ? portraitClass : landscapeClass);
      };

      var ids = ['ICO-card-front', 'ICO-card-back', 'ICO-success-card'];
      ids.forEach(function(id){
         var img = document.getElementById(id);
         if(!img){ return; }
         if(img.complete && img.naturalWidth){
            setClassForImage(img);
         }else{
            img.addEventListener('load', function handler(){
               img.removeEventListener('load', handler);
               setClassForImage(img);
            });
         }
      });
   },

   setCSS : function(variable, value){
      if(value !== undefined){
         document.documentElement.style.setProperty(variable, value);
      }
   },

   optionalParams : function(){
      var settings = ICO.settings;
      var params   = ICO.params;

      // Simple setting to parameter mappings
      var map = {
         'ship_id'       : 'shipID',
         'pay_on_checkout': 'payOnCheckout',
         'change_quantity': 'changeQuantity',
         'cart'          : 'shoppingCart',
         'int_ship'      : 'intShip',
         'per_card_cost' : 'apiUrl'
      };
      Object.keys(map).forEach(function(key){
         if(settings[key] !== undefined){
            params[map[key]] = settings[key];
         }
      });

      ICO.instance = params.instance ?? '';

      ICO.viewsBc = params.payOnCheckout ?
         ['ICO-create-bc','ICO-preview-bc','ICO-shipping-bc','ICO-payment-bc'] :
         ['ICO-create-bc','ICO-preview-bc','ICO-shipping-bc'];

      if(settings.staging){
         ICO.vars.apiUrl = ICO.vars.stagingUrl;
      }

      ICO.setCSS('--ICO-theme-color', settings.color);
      ICO.setCSS('--ICO-accent-color', settings.accent_color);
      ICO.setCSS('--ICO-font-family', settings.font_family);

      if(params.shoppingCart){
         ICO.loadScript(ICO.scriptURL + 'ICO_cart.js?t='+ICO.buildNumber);
      }

      ICO.croppieReady = ICO.loadScript(ICO.scriptURL + 'vendor/croppie.js');

      settings.holding  = settings.holding  ?? false;
      settings.no_back  = settings.no_back  ?? false;
      settings.redirect = settings.redirect ?? false;

      if(settings.fixed_address){
         var fa = settings.fixed_address;
         ICO.vars.sName     = fa.name;
         ICO.vars.sAddress1 = fa.address1;
         ICO.vars.sAddress2 = fa.address2 || '';
         ICO.vars.sCity     = fa.city;
         ICO.vars.sState    = fa.state;
         ICO.vars.sZip      = fa.zip;
         ICO.vars.sCountry  = fa.country || 'US';
         settings.fixed_address = true;
      }else{
         settings.fixed_address = false;
      }

      settings.uppercase = settings.uppercase || {enabled:false};

      if(settings.photo_mag !== undefined){
         ICO.vars.ICOIPM = settings.photo_mag;
      }

      if(!settings.qrcard || settings.qrcard.enabled !== true){
         settings.qrcard = {enabled:false};
      }else{
         if(settings.qrcard.dark_color){
            params.QRColorDk = settings.qrcard.dark_color;
         }
         if(settings.qrcard.light_color){
            params.QRColorLt = settings.qrcard.light_color;
         }

         ICO.loadScript(ICO.scriptURL + 'vendor/nameParse.js');
         ICO.loadScript(ICO.scriptURL + 'vendor/qrcode.min.js');
      }
     },

   
  /**
   * Builds the breadcrumb navigation and top anchor.
   * @returns {DocumentFragment} Fragment containing anchor and breadcrumb container.
   */
  buildBreadcrumbs: function(){
      var frag = document.createDocumentFragment();
      var anc = document.createElement('a');
      anc.setAttribute('name','ICO-top');
      frag.appendChild(anc);
      var bc = document.createElement('div');
      bc.setAttribute('id','ICO-breadcrumbs');
      frag.appendChild(bc);
      return frag;
  },

  /**
   * Builds the card upload form and waiting spinner sections.
   * @returns {DocumentFragment} Fragment with upload and waiting containers.
   */
  buildUploadSection: function(){
      var frag = document.createDocumentFragment();

      var alert = document.createElement('div');
      alert.setAttribute('id','ICO-alert');
      frag.appendChild(alert);

      var ud = document.createElement('div');
      ud.setAttribute('id','ICO-create');
      ud.setAttribute('class','ICO-center ICO-create');
      frag.appendChild(ud);
      ICO.views.push('ICO-create');

      var pl = document.createElement('div');
      pl.setAttribute('id','ICO-waiting');
      pl.setAttribute('class','ICO-center ICO-create ICO-portrait');
      pl.style.display = 'none';
      var spinner = document.createElement('div');
      spinner.setAttribute('id','ICO-waiting-spinner');
      spinner.setAttribute('class','ICO-spinner');
      var waitText = document.createElement('h3');
      waitText.setAttribute('class','ICO-msg');
      waitText.appendChild(document.createTextNode(ICO.vars.pleaseWait));
      pl.appendChild(spinner);
      pl.appendChild(waitText);
      frag.appendChild(pl);
      ICO.views.push('ICO-waiting');

      return frag;
  },

  /**
   * Builds the card preview section shown before submission.
   * @returns {HTMLElement} Preview container.
   */
  buildPreviewSection: function(){
      var pd = document.createElement('div');
      pd.setAttribute('id','ICO-preview');
      pd.style.display = 'none';
      pd.setAttribute('class','ICO-center ICO-preview');

      var ptbl = document.createElement('table');
      ptbl.setAttribute('id','ICO-preview-table');
      if(ICO.settings.no_back == true){
         ptbl.setAttribute('class','ICO-preview-table-single ICO-center');
      }else{
         ptbl.setAttribute('class','ICO-preview-table');
      }
      var ptr = document.createElement('tr');
      ptbl.appendChild(ptr);
      var foc = document.createElement('td');
      foc.setAttribute('id','ICO-front-preview');
      ptr.appendChild(foc);

      if(ICO.settings.no_back == true){
         var fimg = document.createElement('img');
         fimg.setAttribute('id','ICO-card-front');
         fimg.setAttribute('class','ICO-card-img-sing');
         fimg.setAttribute('alt','front of card preview');
         foc.appendChild(fimg);

         var fcap = document.createElement('p');
         fcap.setAttribute('class','ICO-img-label');
         fcap.appendChild(document.createTextNode(ICO.vars.frontOnly));
         foc.appendChild(fcap);
      }else{
         var boc = document.createElement('td');
         boc.setAttribute('id','ICO-back-preview');
         ptr.appendChild(boc);

         var fimg = document.createElement('img');
         fimg.setAttribute('id','ICO-card-front');
         fimg.setAttribute('class','ICO-card-img');
         fimg.setAttribute('alt','front of card preview');
         var bimg = document.createElement('img');
         bimg.setAttribute('id','ICO-card-back');
         bimg.setAttribute('class','ICO-card-img');
         bimg.setAttribute('alt','back of card preview');
         foc.appendChild(fimg);
        boc.appendChild(bimg);

         var fcap = document.createElement('p');
         fcap.setAttribute('class','ICO-img-label');
         fcap.appendChild(document.createTextNode(ICO.vars.frontPreview));
         var bcap = document.createElement('p');
         bcap.setAttribute('class','ICO-img-label');
         bcap.appendChild(document.createTextNode(ICO.vars.backPreview));
         foc.appendChild(fcap);
         boc.appendChild(bcap);
      }

      pd.appendChild(ptbl);
      ICO.views.push('ICO-preview');
      return pd;
  },

  /**
   * Builds the shipping section container.
   * @returns {HTMLElement} Shipping container.
   */
  buildShippingSection: function(){
      var sd = document.createElement('div');
      sd.setAttribute('id','ICO-shipping');
      sd.setAttribute('class','ICO-center ICO-shipping');
      sd.style.display = 'none';
      ICO.views.push('ICO-shipping');
      return sd;
  },

  /**
   * Builds the payment section container.
   * @returns {HTMLElement} Payment container.
   */
  buildPaymentSection: function(){
      var pr = document.createElement('div');
      pr.setAttribute('id','ICO-payment');
      pr.setAttribute('class','ICO-center ICO-payment');
      pr.style.display = 'none';

      var tc = document.createElement('div');
      tc.setAttribute('id','ICO-payment-total');
      tc.setAttribute('class','ICO-center');
      pr.appendChild(tc);
      var pf = document.createElement('div');
      pf.setAttribute('id','ICO-payment-form');
      pf.setAttribute('class','ICO-center');
      pr.appendChild(pf);

      var payAlerts = document.createElement('div');
      payAlerts.id = 'ICO-pay-alerts';
      pr.appendChild(payAlerts);

      ICO.views.push('ICO-payment');
      return pr;
  },

  /**
   * Builds the success message section shown after order submission.
   * @returns {HTMLElement} Success container.
   */
  buildSuccessSection: function(){
      var sc = document.createElement('div');
      sc.setAttribute('id','ICO-success');
      sc.setAttribute('class','ICO-center ICO-payment ICO-portrait');
      sc.style.display = 'none';
      sc.style.width = '100%';

      var s1 = document.createElement('h1');
      s1.setAttribute('class','ICO_form_title ICO-center');
      s1.id = 'ICO-success-title';
      if (ICO.settings.holding == false){
         s1.appendChild(document.createTextNode(ICO.vars.successH1));
      } else {
         s1.appendChild(document.createTextNode(ICO.vars.holdingH1));
      }
      sc.appendChild(s1);

      var s2 = document.createElement('p');
      s2.setAttribute('class','ICO-center');
      s2.id = 'ICO-success-sub';
      if (ICO.settings.holding == false){
         s2.appendChild(document.createTextNode(ICO.vars.successH2));
      } else {
         s2.appendChild(document.createTextNode(ICO.vars.holdingH2));
      }
      sc.appendChild(s2);
      var simg = document.createElement('img');
      simg.setAttribute('id','ICO-success-card');
      simg.setAttribute('class','ICO-card-img-fin');
      simg.setAttribute('alt','your card is on its way');
      sc.appendChild(simg);

      ICO.views.push('ICO-success');
      return sc;
  },

  /**
   * Builds the footer section.
   * @returns {HTMLElement} Footer container.
   */
  buildFooter: function(){
      var foot = document.createElement('div');
      foot.setAttribute('id','ICO-footer');
      foot.setAttribute('class','ICO-center ICO-breadcrumbs');
      foot.style.width = '100%';
      foot.innerHTML = ICO.vars.footer;
      return foot;
  },

  /**
   * Orchestrates building the page layout using helper builders.
   */
  layout: function(){
      var div = ICO.vars.div = document.getElementById(ICO.settings.my_div);
      div.appendChild(ICO.buildBreadcrumbs());
      ICO.breadcrumbs();
      div.appendChild(ICO.buildUploadSection());
      div.appendChild(ICO.buildPreviewSection());
      div.appendChild(ICO.buildShippingSection());
      div.appendChild(ICO.buildPaymentSection());
      div.appendChild(ICO.buildSuccessSection());
      div.appendChild(ICO.buildFooter());
      ICO.get_card_fields();
  },

  //GET card fields  
  get_card_fields: function(){

        var set = {
          'url': ICO.vars.apiUrl+'organizations/' + ICO.settings.organization_id + '/card_templates/' + ICO.settings.card_template_id + '/fields/',
          'method': 'GET',
          'headers': {
            'Authorization': 'bearer ' + ICO.settings.api_token,
            'cache-control': 'no-cache',
                },
        }

                ICO.ajax(set).then(function (response) {
		  //To avoid loading colnflics I add buttons / the shipping form elements here.                  
		  if (ICO.settings.debug === true)
              {console.log("Card Fields:");
               console.log(response);} 
         if (ICO.settings.fixed_address === false){
		      ICO.makeButtons('ICO-create', 'ICO-preview', ICO.vars.shipBut, 'ICO.approvedCard()'); 
         }else ICO.makeButtons('ICO-create', 'ICO-preview', ICO.vars.contactBut, 'ICO.approvedCard()');

		  ICO.shippingForm();
      	ICO.paymentForm();
    

	if (response.length==0){
		ICO.vars.noData=true;

		
	} 
	  ICO.fields = response;
	  ICO.create_form().then(function(){
         ICO.applyQueryParamsToFields();
      });
	  ICO.getPrice();

	});
  },

        //Form fields use CSS class .ICO-text-input
        create_form: function(){
      ICO.calcFields=[];

      var buildForm = function(){
                var fieldsLength = ICO.fields.length;

                for (var i = 0; i < fieldsLength; i++){

                ICO.vars.uploadCrop = [];

      if (ICO.fields[i].type == 'image'){
         if (ICO.fields[i].label !== 'qr-gen'){
         ICO.uploadPhoto(ICO.fields[i], i);
         } else if (ICO.settings.qrcard.enabled === true){
            ICO.qrGen(ICO.fields[i], i);
         } else alert("please enable \"qrcard\" in parameters when using images with name \"qr-gen\"");

      } else if (ICO.fields[i].type == 'text') {
         ICO.addTextToForm(ICO.fields[i], i);
      } else if (ICO.fields[i].type == 'selectbox') {
         ICO.addSelectBox(ICO.fields[i], i);
      } else if (ICO.fields[i].type == 'checkbox') {
         ICO.addCheckBox(ICO.fields[i], i);
      }else if(ICO.fields[i].type == 'calculated_date'){
         var calcDate = ICO.addTextToForm(ICO.fields[i], i);
         ICO.calcFields.push(calcDate);
         calcDate.style.display='none';

      }else {
         ICO.addTextToForm(ICO.fields[i], i);
      };
        }

        ICO.finishForm();
      };

      return ICO.croppieReady.then(buildForm);


   },
 	
 	finishForm : function(){
 		var div = document.getElementById('ICO-create');
 		
 		var alerts = document.createElement('div');
 		alerts.setAttribute('id','ICO-form-alerts');
 		div.appendChild(alerts);
		
		var buttonWrap = document.createElement('div');
		buttonWrap.setAttribute('class','ICO-upload-btn ICO-center ICO-submit-button');
		buttonWrap.setAttribute('onclick','ICO.checkForm()');
		buttonWrap.setAttribute('id','ICO-preview-button');
		div.appendChild(buttonWrap);
		var subButton = document.createElement('button');
		subButton.setAttribute('class','ICO-btn ICO-center');
		subButton.appendChild(document.createTextNode('Preview Card'));
		buttonWrap.appendChild(subButton);

	  	if (ICO.vars.noData == true){
  			ICO.checkForm();
	  	}
 	}, 

   applyQueryParamsToFields: function(){
      if(typeof window === 'undefined' || !window.location || !window.location.search){
         return;
      }

      var params = new URLSearchParams(window.location.search);
      if(!params || params.toString() === ''){
         return;
      }

      var fieldsLength = ICO.fields ? ICO.fields.length : 0;
      for (var i = 0; i < fieldsLength; i++){
         var field = ICO.fields[i];
         var token = field.token;
         if(!token || !params.has(token)){
            continue;
         }

         var input = document.getElementById(token);
         if(!input){
            continue;
         }

         var value = params.get(token);
         var applied = ICO.setFieldValueFromQuery(field, input, value);
         if(applied){
            ICO.hidePrefilledField(field, i, input);
         }
      }
   },

   setFieldValueFromQuery: function(field, input, value){
      if(field.type === 'checkbox'){
         var val = (value || '').toString().toLowerCase();
         input.checked = (val === 'true' || val === '1' || val === 'yes' || val === 'on');
         return true;
      }else if(field.type === 'selectbox'){
         input.value = value;
         return input.value === value;
      }else{
         input.value = value;
         return true;
      }
   },

   hidePrefilledField: function(field, ind, input){
      var containerId;
      if(field.type === 'selectbox'){
         containerId = 'ICO-select-input-' + ind;
      }else if(field.type === 'checkbox'){
         containerId = 'ICO-check-input-' + ind;
      }else{
         containerId = 'ICO-text-input-' + ind;
      }

      var container = document.getElementById(containerId);
      if(container){
         container.style.display = 'none';
      }else if(input){
         input.style.display = 'none';
      }
   },

   uppercase : function(ids){
      var l = ids.length;
      for (var i =0; i<l; i++){
         var inp = document.getElementById(ids[i]);
         console.log(ids[i] + ' old value is ' + inp.value);
         var upVal = inp.value.toUpperCase();
         inp.value = upVal;
         console.log(ids[i] + ' new value is ' + inp.value);
      }
   },

   validateFields: function(){
      ICO.formComplete = true;
      for (var i = 0; i < ICO.fields.length; i++){
         var field = ICO.fields[i];
         if (field.type !== 'image'){
            var fID = document.getElementById(field.token);
            var repQ = ICO.repQuotes(fID.value);
            fID.value = repQ;
            ICO.CheckRequired(fID);
         }else{
            ICO.CheckImages(field, i);
         }
      }
      return ICO.formComplete;
   },

   renderFormAlerts: function(isValid){
      var alerts = document.getElementById('ICO-form-alerts');
      ICO.clearAlerts();
      if(!isValid){
         var incompleteAlert = document.createElement('p');
         incompleteAlert.setAttribute('class','ICO-alerts');
         incompleteAlert.appendChild(document.createTextNode(ICO.vars.reqFields));
         alerts.appendChild(incompleteAlert);
      }
   },

       checkForm : function(){
      //Avoid anyone messing with a calculated date in console
      ICO.clearCalcDates(ICO.calcFields);

      //Check to see if any fields need uppercase
      if (ICO.settings.uppercase.enabled === true){
         ICO.uppercase(ICO.settings.uppercase.ids);
      }
      var isValid = ICO.validateFields();
      ICO.renderFormAlerts(isValid);

      if (isValid) {
         ICO.submitCardData();
      }

       },
 	
 	submitCardData : function(){

 		ICO.cardData = [];

	   //var fieldsLength = ICO.fields.length;

		for (var i = 0; i < ICO.fields.length; i++){
 
		   if (ICO.fields[i].type == 'image'){
		   	ICO.inputImage(ICO.fields[i], i);    
		   } else {	      
				ICO.inputObject(ICO.fields[i], i);
		   };
		};
		

                var form = new FormData();
             ICO.appendFields(form, {
                'card[data]': '['+ICO.cardData+']',
                'card[card_template_id]': ICO.settings.card_template_id
             });

     var requestConfig = {
       url: ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id + '/cards/',
       method: 'POST',
       headers: {
         'authorization': 'bearer '+ ICO.settings.api_token,
         'cache-control': 'no-cache'
       },
       data: form
     };

   function handleSubmitSuccess(response){
      ICO.viewSwitch('ICO-waiting');
      if (ICO.settings.debug == true){
           console.log(response);
      }
      ICO.vars.id = response.id;
      //I initializ the payment form here to avoid conflict. It also depends on the shipping form, su muust be called after that function is executed
      ICO.previewCard();
   }

   function handleSubmitError(err){
      if (ICO.settings.debug == true){
             console.log(err);
      }
      ICO.callError(ICO.vars.createError);
   }

   ICO.ajax(requestConfig).then(handleSubmitSuccess).catch(handleSubmitError);
		   
 	},
	
 	previewCard : function(){

                  var form = new FormData();

     var settings = {
       'url': ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id + '/cards/'+ICO.vars.id+'/preview',
       'method': 'GET',
       'headers': {
         'authorization': 'bearer '+ ICO.settings.api_token,
         'cache-control': 'no-cache'
       },
       'data': form,
                'error': function(xhr){
              if (ICO.settings.debug == true)
               {console.log(xhr);}
                ICO.tryAgain();
       }

     };

     ICO.ajax(settings).then(function (resp) {
              if (ICO.settings.debug == true)
                   {console.log(resp);}

      if (ICO.settings.no_back == true){

         if (resp.orientation=='portrait'){

            var front = document.getElementById('ICO-card-front');
            var finCard = document.getElementById('ICO-success-card');
            
            front.className = front.className.replace(/\bICO-card-img\b/g, 'ICO-card-img-port');
             finCard.className = finCard.className.replace(/\bICO-card-img-fin\b/g, 'ICO-card-img-fin-port');
            
         }
         
         if (resp.preview_available==true){
      
            ICO.viewSwitch('ICO-preview');         

            ICO.vars.idFront = 'data:image/jpeg;base64,'+ resp.front;
               
            document.getElementById('ICO-card-front').setAttribute('src', ICO.vars.idFront);
            document.getElementById('ICO-success-card').setAttribute('src', ICO.vars.idFront);


         } else {
            document.getElementById('ICO-preview').innerHTML = previewError;
         }
      } else{
         if (resp.orientation=='portrait'){

            var front = document.getElementById('ICO-card-front');
            var back = document.getElementById('ICO-card-back');
            var finCard = document.getElementById('ICO-success-card');
            
            front.className = front.className.replace(/\bICO-card-img\b/g, 'ICO-card-img-port');
            back.className = back.className.replace(/\bICO-card-img\b/g, 'ICO-card-img-port');
            finCard.className = finCard.className.replace(/\bICO-card-img-fin\b/g, 'ICO-card-img-fin-port');
            
         }
         
         if (resp.preview_available==true){
      
            ICO.viewSwitch('ICO-preview');         

            ICO.vars.idFront = 'data:image/jpeg;base64,'+ resp.front;
            ICO.vars.idBack = 'data:image/jpeg;base64,'+ resp.back;
            
            document.getElementById('ICO-card-front').setAttribute('src', ICO.vars.idFront);
            document.getElementById('ICO-success-card').setAttribute('src', ICO.vars.idFront);
            
            document.getElementById('ICO-card-back').setAttribute('src', ICO.vars.idBack);

            ICO.adjustPreviewImages();

         } else {
            document.getElementById('ICO-preview').innerHTML = previewError;
         }
      }
     });
   
 	},
 	
        finalizeCard : function(){
                var settings = {
             'url': ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id + '/cards/'+ICO.vars.id+'/finalize/',
             'method': 'PATCH',
             'headers': {
               'authorization': 'bearer '+ ICO.settings.api_token,
               'cache-control': 'no-cache'
                },
                'error' : function(xhr){
                         if (ICO.settings.debug == true)
                     {console.log(xhr);}

                        if (xhr.responseText == '{\"error\":\"Card is already finalized\"}'){ 
                        } else ICO.tryAgain();

                        },
           };

           ICO.ajax(settings).then(function (response) {
              if (ICO.settings.debug == true)
            {console.log(response);}

           });


                },
 	
 	printJob : function(){
 		ICO.clearAlerts();
 	
 		if (ICO.vars.sCountry !== 'US' && ICO.vars.sCountry !== 'CA'){
 			ICO.params.shipID = ICO.vars.intShipId;
 		}
 		

           var form = new FormData();
           ICO.appendFields(form, {
              'print_job[card_ids]': '['+ ICO.vars.id +']',
              'print_job[shipping_provider_id]': ICO.params.shipID+'',
              'print_job[address][contact][full_name]': ICO.vars.sName+'',
              'print_job[address][address1]': ICO.vars.sAddress1+'',
              'print_job[address][address2]': ICO.vars.sAddress2+'',
              'print_job[address][city]': ICO.vars.sCity+'',
              'print_job[address][state]': ICO.vars.sState+'',
              'print_job[address][zip_code]': ICO.vars.sZip+'',
              'print_job[address][country]': ICO.vars.sCountry+'',
              'print_job[number_of_copies]': ICO.vars.quantity+''
           });

         var requestConfig = {
           url: ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id + '/print_jobs/',
           method: 'POST',
           headers: {
             'authorization': 'bearer '+ ICO.settings.api_token,
             'cache-control': 'no-cache'
           },
           data: form
         };

         function handlePrintJobSuccess(resp){
      if (ICO.settings.debug == true)
           {console.log(resp);}
           ICO.vars.orderId = resp.id;
           if(ICO.params.payOnCheckout == false){
                ICO.noPayment();
           } else ICO.finalCost();
         }

         function handlePrintJobError(xhr){

         if (ICO.settings.debug == true)
            {console.log(xhr);}
                ICO.viewSwitch('ICO-shipping');
                var e = document.createElement('p');
                e.setAttribute('class','ICO-alerts');
                e.appendChild(document.createTextNode(ICO.vars.apiShipError));
                document.getElementById('ICO-ship-alerts').appendChild(e);
            }

         ICO.ajax(requestConfig).then(handlePrintJobSuccess).catch(handlePrintJobError);
	},
	
	finalCost: function(){

         var settings = {
            'url': ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id +'/print_jobs/'+ ICO.vars.orderId +'/charge_details/',
            'method': 'GET',
            'headers': {
               'Authorization': 'bearer '+ ICO.settings.api_token,
               'Cache-Control': 'no-cache',
            },
            'error' : function(data){
            if (ICO.settings.debug == true)
                 {console.log(data);}
               ICO.callError(ICO.vars.refresh);
            },
         };

      ICO.ajax(settings).then(function (response) {
         if (ICO.settings.debug == true)
            {console.log(response);}

            ICO.settings.finalCost = parseFloat(response.job_total_cost.substr(1)) * 100;
            var totDiv = document.getElementById('ICO-total-cost') ;
            totDiv.innerHTML = '';
         
            ICO.vars.total = ICO.settings.finalCost * .01;
         
            var msg = ICO.vars.totalCost + '<span class=\'ICO-cost\'>$' + ICO.vars.total.toFixed(2) + '</span> for ' + ICO.vars.quantity + ' ' + ICO.vars.cardOrCards + '.'      
            totDiv.innerHTML = msg; 
});	   		
	},
 	
 	checkShipForm : function(){
 	
		//this is redundant to some code here, but I wanted to avoid conflicts in declaration order. 
 		ICO.shipVars(); 	
 		
 		var alerts = document.getElementById('ICO-ship-alerts');
 		
 		alerts.innerHTML = '';
 		
	  var incompleteAlert = document.createElement('p');
     incompleteAlert.setAttribute('class','ICO-alerts');
     incompleteAlert.appendChild(document.createTextNode(ICO.vars.reqFields));
     
	   var emailAlert = document.createElement('p');
	   emailAlert.setAttribute('class','ICO-alerts');
	   emailAlert.appendChild(document.createTextNode(ICO.vars.emailAlert));
	   
	   var copies = document.getElementById('ICO-copies');
  
      var copiesAlert = document.createElement('p');
      copiesAlert.setAttribute('class','ICO-alerts');
      copiesAlert.appendChild(document.createTextNode(ICO.vars.copiesAlert));
     
     var fieldsLength = ICO.shipFields.length;
     
     ICO.formComplete = true;
 
     for (var i = 0; i < fieldsLength; i++){
        var field = ICO.shipFields[i];

        ICO.CheckRequired(document.getElementById(field), ICO.formComplete);

     }
     
     var e1 = document.getElementById('ICO-ship-email1');
     var e2 = document.getElementById('ICO-ship-email2');

      if (ICO.settings.fixed_address === false){     
         if (ICO.formComplete == false){
            document.getElementById('ICO-ship-alerts').appendChild(incompleteAlert);   
         } else if (e1.value != e2.value) {
            e1.classList.toggle('ICO_text_input_req');
            e2.classList.toggle('ICO_text_input_req');
            document.getElementById('ICO-ship-alerts').appendChild(emailAlert);
         } else if (parseInt(copies.value) < parseInt(copies.min) || parseInt(copies.value) > parseInt(copies.max)){
            document.getElementById('ICO-ship-alerts').appendChild(copiesAlert);     
         }else {
               ICO.printJob();
            if (ICO.params.payOnCheckout == true){

               ICO.payment();
            }	     	
            }
      }else {
         if (e1.value != e2.value) {
            e1.classList.toggle('ICO_text_input_req');
            e2.classList.toggle('ICO_text_input_req');
            document.getElementById('ICO-ship-alerts').appendChild(emailAlert);
         } else if (parseInt(copies.value) < parseInt(copies.min) || parseInt(copies.value) > parseInt(copies.max)){
            document.getElementById('ICO-ship-alerts').appendChild(copiesAlert);     
         }else {
               ICO.printJob();
            if (ICO.params.payOnCheckout == true){
               ICO.payment();
            }	     	
            }
      }
 		
 	},
 	
 	payment : function(){
     
		ICO.viewSwitch('ICO-payment');
 	},
	
	completePayment : function(){
		ICO.viewSwitch('ICO-waiting');
		ICO.clearAlerts();
		
		ICO.vars.cc = document.getElementById('ICO-cc-number').value;
		ICO.vars.ccM = document.getElementById('ICO-cc-month').value;
		ICO.vars.ccY = document.getElementById('ICO-cc-year').value;
		ICO.vars.ccCVC = document.getElementById('ICO-cc-cvc').value;

	
		var sAd = document.getElementById('ICO-bill-address-toggle');

		if	(ICO.settings.fixed_address == false && sAd.checked == true){
			ICO.vars.pName = ICO.vars.sName;
			ICO.vars.pAddress1 = ICO.vars.sAddress1;
			ICO.vars.pAddress2 = ICO.vars.sAddress2;
			ICO.vars.pCity = ICO.vars.sCity;
         ICO.vars.pState = ICO.vars.sState;
         ICO.vars.pZip = ICO.vars.sZip;
         ICO.vars.pCountry = ICO.vars.sCountry;	
		}else{
         ICO.vars.pName = document.getElementById('ICO-bill-name').value;
         ICO.vars.pAddress1 = document.getElementById('ICO-bill-address1').value; 
         ICO.vars.pAddress2 = document.getElementById('ICO-bill-address2').value;  
         ICO.vars.pCity = document.getElementById('ICO-bill-city').value;
         ICO.vars.pState = document.getElementById('ICO-bill-state').value;
         ICO.vars.pZip = document.getElementById('ICO-bill-zip').value;	
         ICO.vars.pCountry = document.getElementById('ICO-bill-country').value;	
		}
		
                var form = new FormData();
                ICO.appendFields(form, {
                   'number': ICO.vars.cc+'',
                   'exp_month': ICO.vars.ccM+'',
                   'exp_year': ICO.vars.ccY+'',
                   'cvc': ICO.vars.ccCVC+'',
                   'full_name': ICO.vars.pName+'',
                   'billing_address1': ICO.vars.pAddress1+'',
                   'billing_address2': ICO.vars.pAddress2+'',
                   'billing_country': ICO.vars.pCountry || 'USA',
                   'billing_city': ICO.vars.pCity+'',
                   'billing_state': ICO.vars.pState+'',
                   'billing_zip_code': ICO.vars.pZip+'',
                   'email': ICO.vars.email+''
                });

                var requestConfig = {
                url: ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id +'/print_jobs/'+ ICO.vars.orderId +'/print/',
                method: 'POST',
                headers: {
                  'authorization': 'bearer '+ ICO.settings.api_token,
                  'cache-control': 'no-cache'

                },
                 data: form
                };

                function handlePaymentSuccess(resp){
         if (ICO.settings.debug == true)
           {console.log(resp);}

                       if(resp.status=='Scheduled'){
                                        ICO.viewSwitch('ICO-success');
                                        ICO.vars.cc = '';
               ICO.redirect();
                      } else if (resp.status=='Pending_Approval'){
                      //console.log('pending approval');
                         ICO.viewSwitch('ICO-success');
                         ICO.vars.cc = '';
                         ICO.redirect();
            } else{
                        ICO.tryAgain();
                      }


                }

                function handlePaymentError(xhr){
         if (ICO.settings.debug == true)
          {console.log(xhr);}
                          var payError = JSON.parse(xhr.responseText).error;
                          ICO.viewSwitch('ICO-payment');

                          var error = document.createElement('p');
                          error.setAttribute('class', 'ICO-alerts');
                          error.appendChild(document.createTextNode(payError));
                          document.getElementById('ICO-pay-alerts').appendChild(error);
                          }

                 ICO.ajax(requestConfig).then(handlePaymentSuccess).catch(handlePaymentError);
					
	},
   breadcrumbs : function(){
   
      //table for breadcrumbs
      var bctbl = document.createElement('table');
         bctbl.setAttribute('id','ICO-bc-table');
         bctbl.setAttribute('class','ICO-bc-table ICO-breadcrumbs ICO-center');
      var bctr = document.createElement('tr');
         bctbl.appendChild(bctr);

      var infobc = document.createElement('td');
         infobc.setAttribute('id', 'ICO-create-bc');
         infobc.setAttribute('class', 'ICO-breadcrumbs-active ICO-tooltip');
         bctr.appendChild(infobc);
         infobc.appendChild(document.createTextNode(ICO.vars.infoBc));
      var infott = document.createElement('span');
         infott.setAttribute('class','ICO-tooltiptext');
         infott.appendChild(document.createTextNode(ICO.vars.infoTt));
         infobc.appendChild(infott);

      var s1 = document.createElement('td');
      s1.setAttribute('id', 'ICO-s1-bc');
      bctr.appendChild(s1);
      s1.appendChild(document.createTextNode(ICO.vars.dividerBc));
      
      var prev = document.createElement('td');
         prev.setAttribute('id', 'ICO-preview-bc');
         prev.setAttribute('class', 'ICO-tooltip');
         bctr.appendChild(prev);
         prev.appendChild(document.createTextNode(ICO.vars.previewBc));	
      var prevtt = document.createElement('span');
      prevtt.setAttribute('class','ICO-tooltiptext');
      prevtt.appendChild(document.createTextNode(ICO.vars.previewTt));
      prev.appendChild(prevtt);	
      
      var s2 = document.createElement('td');
      s2.setAttribute('id', 'ICO-s2-bc');
      bctr.appendChild(s2);
      s2.appendChild(document.createTextNode(ICO.vars.dividerBc)); 
      
      var ship = document.createElement('td');
      ship.setAttribute('id', 'ICO-shipping-bc');
      ship.setAttribute('class', 'ICO-tooltip');      
      bctr.appendChild(ship);
      if (ICO.settings.fixed_address === false){
         ship.appendChild(document.createTextNode(ICO.vars.shippingBc));
      }else ship.appendChild(document.createTextNode(ICO.vars.fixedAddBc));
         
      var shiptt = document.createElement('span');
      shiptt.setAttribute('class','ICO-tooltiptext');
      if (ICO.settings.fixed_address === false){
         shiptt.appendChild(document.createTextNode(ICO.vars.shippingTt));
      }else {
         shiptt.appendChild(document.createTextNode(ICO.vars.contactTt));
      }
      ship.appendChild(shiptt);	  
      
		if (ICO.params.payOnCheckout == true){
	      var s3 = document.createElement('td');
	      s3.setAttribute('id', 'ICO-s3-bc');
	      bctr.appendChild(s3);
	      s3.appendChild(document.createTextNode(ICO.vars.dividerBc));    
      
		
	      var pay = document.createElement('td');
	      pay.setAttribute('id', 'ICO-payment-bc');
	      pay.setAttribute('class', 'ICO-tooltip');       
	      bctr.appendChild(pay);
	      pay.appendChild(document.createTextNode(ICO.vars.paymentBc));    
	      var paytt = document.createElement('span');
	      paytt.setAttribute('class','ICO-tooltiptext');
	      paytt.appendChild(document.createTextNode(ICO.vars.paymentTt));
	      pay.appendChild(paytt);	  
	      }                
      
      document.getElementById('ICO-breadcrumbs').appendChild(bctbl);    	
   },	
   
   noPayment : function (){

   	ICO.viewSwitch('ICO-waiting');
   	ICO.clearAlerts();


      var settings = {
      'url': ICO.vars.apiUrl+'organizations/'+ ICO.settings.organization_id +'/print_jobs/'+ ICO.vars.orderId +'/print/',
      'method': 'POST',
      'headers': {
        'authorization': 'bearer '+ ICO.settings.api_token,
        'cache-control': 'no-cache',

      },
      'error': function(xhr){
               if (ICO.settings.debug == true)
                    {console.log(xhr);}
                var payError = JSON.parse(xhr.responseText).error;
                ICO.viewSwitch('ICO-shipping');

                var error = document.createElement('p');
                error.setAttribute('class', 'ICO-alerts');
                error.appendChild(document.createTextNode(payError));
                document.getElementById('ICO-ship-alerts').appendChild(error);
                }
       };

       ICO.ajax(settings).then(function (response) {
         if (ICO.settings.debug == true)
           {console.log(response);}
         
             if(response.status=='Scheduled'){
               ICO.viewSwitch('ICO-success');
               ICO.vars.cc = '';
               console.log('scheduled');
               ICO.redirect();
            } else if (response.status=='Pending_Approval'){
            	ICO.viewSwitch('ICO-success');
               ICO.vars.cc = '';
               console.log('pending approval');
               ICO.redirect();
            } else{ 
               ICO.tryAgain();
            }


       });
   },
   
   repQuotes : function (str){
   	return str.replace('\"','\'\'')   	
   },

   redirect : function(){
      
      if (ICO.settings.redirect == false){
         console.log('not redirecting');
      }else {
         console.log('redirecting');
         window.location.href = ICO.settings.redirect;
      }

   },

}

export default ICO;
